module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_b1_dark.95f58233.svg";